import * as React from "react";

import type { DesignaliProps } from "../../types";

export const MegaphoneOff = React.forwardRef<SVGSVGElement, DesignaliProps>(
  ({ ...props }, forwardedRef) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        {...props}
        ref={forwardedRef}
      >
        <path d="M9.26 9.26 3 11v3l14.14 3.14" />
        <path d="M21 15.34V6l-7.31 2.03" />
        <path d="M11.6 16.8a3 3 0 1 1-5.8-1.6" />
        <line x1="2" x2="22" y1="2" y2="22" />
      </svg>
    );
  },
);

export default MegaphoneOff;
